import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { RoleUrl } from './RoleUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { PageRequestParams } from '../../common/queryClient';
import { AUTOCOMPLETE_PAGE_SIZE, OptionsPage } from '../../common/queryClient';
import { RoleFilter, RoleListDto } from '../schema/types';
import { RolePageSchema } from '../schema/RoleSchema';
import { QueryFunctionContext } from '@tanstack/react-query';
import { useInfiniteSearchQuery } from '../../common/queryClient/useInfiniteSearchQuery';

const getRoles = (params: RoleFilter & PageRequestParams) =>
  apiClient
    .get<RoleListDto>(expand(RoleUrl.SEARCH, params))
    .then((response) => RolePageSchema.parse(response.data));

export const useRolesQuery = createApiQueryHook(['roles'], getRoles);

interface RoleSearchOptions {
  selectedIds?: number[];
}

const searchRoleOptions = async ({
  meta,
  pageParam,
}: QueryFunctionContext<any, number>): Promise<OptionsPage> => {
  const response = await apiClient.get<RoleListDto>(
    expand(RoleUrl.SEARCH, {
      name: (meta?.searchText ?? '') as string,
      selectedIds: meta?.selectedIds as number[] | undefined,
      page: pageParam ?? 0,
      size: AUTOCOMPLETE_PAGE_SIZE,
      sort: 'name,asc',
    }),
  );
  const page = RolePageSchema.parse(response.data);

  return {
    content: page.content.map((item) => ({
      value: item.id,
      label: item.name,
    })),
    last: page.last,
    number: page.number,
  };
};

export const useInfiniteSearchRolesQuery = (
  term: string,
  options?: RoleSearchOptions,
) =>
  useInfiniteSearchQuery(
    ['roles-autocomplete'],
    searchRoleOptions,
    term,
    options,
  );
